import cn from "classnames";
import { Text } from "@/components/text/text.component";
import { ChevronDownIcon } from "@/components/icons/chevronDown.icon";

export const AccordionCompact = ({
  accordionName,
  title,
  children,
}: AccordionCompactProps) => {
  return (
    <details
      name={accordionName}
      className="group border-greyscale-strength/25 border-b">
      <summary
        className={cn(
          "flex cursor-pointer list-none items-center justify-between py-4",
          "[&::-webkit-details-marker]:hidden [&::marker]:content-none",
        )}>
        <Text
          variant="body4"
          component="span"
          className="text-greyscale-headline font-bold tracking-wide uppercase">
          {title}
        </Text>
        <ChevronDownIcon
          width={20}
          height={20}
          className="text-greyscale-body shrink-0 transition-transform duration-200 group-open:rotate-180"
          aria-hidden
        />
      </summary>
      <div className="text-greyscale-body pb-4">{children}</div>
    </details>
  );
};

export type AccordionCompactProps = {
  accordionName: string;
  title: string;
  children: React.ReactNode;
};
